import React from "react";
import ClientReportTableRowColumn from "./ClientReportTableRowColumn";
import { ReportEfficacyDisplay } from "../../../components/ReportEfficacyDisplay";

export type ClientReportTableRowEfficacyColumnProps = {
    efficacy: number,
    size?: 
        | "xs"
        | "lg"
        | "sm"
        | "1x"
        | "2x"
        | "3x"
        | "4x"
        | "5x"
        | "6x"
        | "7x"
        | "8x"
        | "9x"
        | "10x",
    width?: string | number
};

const ClientReportTableRowEfficacyColumn = (
    { width = 5, efficacy, size = "lg" }: Readonly<ClientReportTableRowEfficacyColumnProps>
) => (
    <ClientReportTableRowColumn   ClientReportTableRowColumn width={width} className="text-center">
        <ReportEfficacyDisplay efficacy={efficacy} size={size} />
    </ClientReportTableRowColumn>
);

export default ClientReportTableRowEfficacyColumn;